import styled from 'styled-components';

import { flexStyle } from '@themes/mixins';
import { Box } from '@mui/material';

export const Root = styled(Box)`
  ${flexStyle({
    align: 'center',
    justify: 'center',
    direction: 'row',
    wrap: 'nowrap',
  })};
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.divider};
  border-top: 0;
  padding: 2px 8px 16px;
  border-top-left-radius: 4px;
  box-shadow: 0 4px 20px rgba(47, 143, 232, 0.07);
`;
